export default __webpack_public_path__ + "static/N0106-b03542412ed33d4c5742e2e6ce81567e.png";